export default {
  "addStandard.title": "添加标准品",
  "addStandard.explain":
    "说明：衣柜产品请确定编组后再添加标准品，否则编组/解组操作可能导致标准品数据丢失",
  "addStandard.showCaxa": "是否展示设计自带标准品",
  "addStandard.caseName": "方案名称",
  "addStandard.product": "组合柜",
  "addStandard.productDetail": "标准品明细",
  "addStandard.operate": "操作",
  "addStandard.open": "是",
  "addStandard.close": "否",
  "addStandard.packageType": "套餐类型",
  "addStandard.specifications": "规格",
  "addStandard.productCode": "编码",
  "addStandard.model": "型号",
  "addStandard.classify": "分类",
  "addStandard.details": "详情",
  "addStandard.order": "(下单)",
  "addStandard.notOrder": "(不下单)",
  "addStandard.edit": "编辑",
  "addStandard.designScheme": "(设计自带)",
  "addStandard.parameters": "下单参数",
  "addStandard.FaucetModel": "水龙头型号",
  "addStandard.FaucetCode": "水龙头编码",
  "addStandard.nonStandard": "是否非标",
  "addStandard.installingBasin": "安装方式",
};



// WEBPACK FOOTER //
// ./src/locales/lang/zh-CN/addStandard/settings.js